/**
 * Small display helpers with no React and no API dependency, so they can be unit
 * tested and reused by both work streams without importing a provider.
 */

/**
 * Initials for an avatar — Figma uses two letters ("SP", "PJ", "CP", "SS").
 *
 * First + last word, so "Shailesh Patel" → "SP" and a single-word name → one
 * letter. Never returns an empty string: a blank avatar circle reads as a rendering
 * bug, where "?" reads as "we do not know this person's name".
 */
export function initialsOf(name: string): string {
  const words = name
    .trim()
    .split(/\s+/)
    .filter((word) => word !== '');
  if (words.length === 0) return '?';
  const first = words[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1] ?? '') : '';
  const initials = ((first[0] ?? '') + (last[0] ?? '')).toUpperCase();
  return initials === '' ? '?' : initials;
}

/** First name only — the design greets "Shailesh", not "Shailesh Patel". */
export function firstNameOf(name: string, fallback = 'there'): string {
  const first = name.trim().split(/\s+/)[0];
  return first === undefined || first === '' ? fallback : first;
}
